import React from 'react';
import { jointIllustration } from '../../data/presellContent';
export function Discovery() {
  return <section id="discovery" className="w-full bg-white" data-id="element-5" data-mp="1xcj8875iur01">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-6" data-mp="1xf5gya45fcju">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-7" data-mp="1tbqxtakwyg26">
          <img src={jointIllustration} alt="Illustration comparing a well-lubricated knee joint with one that has lost much of its natural fluid" className="w-full rounded-2xl border border-[#E5E9E7] bg-white" loading="lazy" data-id="element-8" data-mp="1od5zjgp826gd" />

          <div data-id="element-9" data-mp="2c99zft51kwek">
            <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug" data-id="element-10" data-mp="2c91ow7we636j">
              It May Not Be Just "Wear And Tear"
            </h2>

            <p className="mt-6 text-lg text-[#4A5D50] leading-relaxed" data-id="element-11" data-mp="34qe0d6v9hg8l">
              As the body changes over time, joints may lose some of the natural
              fluid that helps cushion and lubricate movement. When that support
              starts to decline, stiffness, discomfort, and reduced mobility may
              become more noticeable.
            </p>

            <p className="mt-8 border-l-4 border-[#3F8C86] bg-[#F2F7F6] rounded-r-xl px-6 py-5 text-lg md:text-xl font-semibold text-[#22322C] leading-relaxed" data-id="element-12" data-mp="d91kahu2jrp5">
              That's why more attention is being given to supporting the body's
              natural joint lubrication.
            </p>
          </div>
        </div>
      </div>
    </section>;
}